import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  Stack,
  Avatar,
  Typography,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Route } from "../../utils/config";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#f7f7f7",
  },
}));

export default function PartnerCard({
  id,
  logoUrl,
  companyName,
  region,
  description,
}) {
  const styles = useStyles();

  return (
    <Grid item key={id} xs={12} sm={6} md={4} lg={3}>
      <Card>
        <CardMedia className={styles.cardHeader}>
          <Stack textAlign="center" alignItems="center" py={2}>
            <Avatar
              src={Route + "/" + logoUrl}
              sx={{ width: 100, height: 100, marginY: 2 }}
            ></Avatar>
            <Link
              to={`/partner/${id}`}
              state={{ id: id }}
              style={{
                color: "black",
                textDecoration: "none",
              }}
            >
              <Typography
                variant="h5"
                fontSize="20px"
                component="div"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                display="block"
                overflow="hidden"
              >
                {companyName}
              </Typography>
            </Link>
          </Stack>
        </CardMedia>

        <CardContent>
          <Grid container alignItems="center" pb={2}>
            <Grid item xs={11}>
              <Typography variant="body2" color="text.secondary">
                {region}
              </Typography>
            </Grid>
          </Grid>

          <Typography variant="body2" color="text.secondary" minHeight={42}>
            {description ? (
              <>
                {description.length > 50
                  ? `${description.slice(0, 50)}...`
                  : description}
              </>
            ) : (
              "No Overview"
            )}
          </Typography>
        </CardContent>
        <CardActions>
          <Button color="primary" variant="contained">
            <Link
              to={`/partner/${id}`}
              state={{ id: id }}
              style={{
                color: "#FFFFFF",
                textDecoration: "none",
              }}
            >
              View Partner
            </Link>
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
